<template>
  <b-container class="media-container" v-if="isActiveSection">
    <b-row class="justify-content-start" no-gutters>
      <b-col class="media-col" v-if="event.brochure">
        <div>MEDIA KIT</div>
        <i class="fas fa-file-archive" />
        <a target="_blank" :href="event.brochure" download>
          <div class="media-download">
            <i class="fa fa-download" aria-hidden="true" />
            Download
          </div>
        </a>
      </b-col>
        <b-col class="media-col" v-if="event.guide">
        <div style="white-space: pre-wrap; overflow-wrap: break-word;">EVENTS GUIDE/BROCHURE</div>
          <i class="fa fa-file-pdf" />
          <a target="_blank" :href="event.guide" download>
            <div class="media-download">
            <i class="fa fa-download" aria-hidden="true" />
            Download
          </div>
        </a>
      </b-col>
      <b-col class="media-col" v-if="(event.floor_plan_link || event.floor_plan) && isAParticipant">
        <div>FLOOR PLAN</div>
          <i class="fa fa-file-pdf" />
          <a @click.prevent="openFloorPlanIframe">
            <div class="media-download">
              <i class="fa fa-link" aria-hidden="true" />
            View
          </div>
        </a>
      </b-col>
      <b-col class="media-col" v-if="event.magazine_link">
        <div>MAGAZINE</div>
        <i class="fa fa-newspaper-o" />
        <a target="_blank" :href="event.magazine_link">
          <div class="media-download">
            <i class="fa fa-link" aria-hidden="true" />
           View
          </div>
        </a>
      </b-col>
    </b-row>
    <ModalFloorPlan
      ref="modalFloorPlan"
      :event="event"
      />
  </b-container>
  <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalFloorPlan from './ModalFloorPlan.vue';

export default {
  name: 'Media',
  components: {
    ModalFloorPlan,
  },
  data() {
    return {
      isAParticipant: false,
    };
  },
  computed: {
    ...mapGetters({
      event: 'events/fetchEvent',
      userInfo: 'user/fetchUserInfo',
    }),
    isActiveSection() {
      return this.event && this.event.available_sections ? this.event.available_sections.includes('media') : false;
    },
  },
  async mounted() {
    await this.fetchEvent(this.$route.params.eventId);
    const participants = await this.getEventParticipantMember({ eventId: this.$route.params.eventId, customerId: this.userInfo.id });
    this.isAParticipant = participants.length > 0;
  },
  methods: {
    ...mapActions({
      fetchEvent: 'events/fetchEvent',
      'getEventParticipantMember' : 'events/getEventParticipantMember',
    }),
    openFloorPlanIframe() {
      this.$refs.modalFloorPlan.$refs.modal.show();
    },
  },
};
</script>

<style scoped>
.media-container {
  padding: 15px;
  margin-bottom: 20px;
}
.media-col {
  max-width: 170px;
  height: 12rem;
  text-align: center;
  margin: 1px 4px;
  background: #fff;
  border-radius: 0 10px 10px;
  overflow: hidden;
}
.media-col > div {
  padding: 8px;
  border-bottom: 2px solid #dbdbdb;
}
.media-col > i {
  color: #dbdbdb;
  font-size: 4rem;
  margin-top: 1.5rem;
}
.media-col > i.fa-file-pdf {
  margin-top: 1rem;
}
.media-download {
  background: #fff;
  color: #BD9D5F;
  width: 100%;
  position: absolute;
  bottom: 0px;
  text-align: center;
  cursor: pointer;
  padding: 8px 14px;
  font-size: 11px;
  border-top: 2px solid #ebebeb;
}
.media-download:hover {
  opacity: 0.5;
  transition: 0.3s;
}
.download-btn {
  background: transparent;
  height: 23px;
  font-size: 12px;
  border: unset;
}
@media (max-width: 1024px) {
  .media-container {
    padding: 0;
    margin: 0;
    max-width: 100%;
  }
  .media-col > div {
    font-size: 12px;
  }
}

@media (max-width: 1024px) {
    .media-col {
      width: 48%;
      min-width: 48%;
      margin-top: 10px;
      max-width: unset !important;
    }
}
@media (max-width: 400px) {
  .media-col {
    width: 46.5%;
    min-width: 46.5%;
    margin-top: 10px;
    max-width: unset !important;
  }
}
</style>
